export { resolve, sep, posix, join, relative, dirname, normalize, isAbsolute, basename } from 'node:path';
